'use client';
var classes = {"root":"m_7f854edf"};

export { classes as default };
//# sourceMappingURL=Affix.module.css.mjs.map
